import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store, select, Action} from '@ngrx/store';
import * as fromStore from '../../store';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map, switchMap, filter, catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import * as actions from '../actions';
import {GroupsService} from '../../services/groups.service';
import * as featureActions from '../../my-features/updateInfo/actions/update-info.actions';
import {UpdateInfoModel} from '../../my-features/updateInfo/update-info.model';
import {errMsgForExceedLimit, updateInfoType} from '../../shareModel';
import {Group} from '../../models/group';

@Injectable()
export class GroupEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private groupService = inject(GroupsService);

  constructor() {}

  readGroup$ = createEffect(() => this.actions$.pipe(
    ofType(actions.GroupActionTypes.GetGroups),
    map((action: actions.GetGroups) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const param = (payload !== null && payload.regionIds !== null && payload.regionIds !== undefined) ?
                    {otp: user.otp, RegionIds: payload.regionIds} : {otp: user.otp};
      return this.groupService.ReadGroups(param).pipe(
        map((res: any) => {
          if (res.result) {
            return new actions.LoadGroups(res.msg.body);
          }
        })
      );
    })
  ));
  updateDeviceGroup$ = createEffect(() => this.actions$.pipe(
    ofType(actions.GroupActionTypes.UpdateDeviceGroup),
    map((action: actions.UpdateDeviceGroup) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const requestPayload = user.isLogin ? { ...payload, otp: user.otp } : payload;
      return this.groupService.UpdateDeviceGroup(requestPayload).pipe(
        map((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.EditDeviceGroup };
          if (result.result) {
            return new featureActions.UpdateInfoSuccessAction(result);
          } else {
            return new featureActions.UpdateInfoFailAction(result);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditDeviceGroup
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  addDeviceGroup$ = createEffect(() => this.actions$.pipe(
    ofType(actions.GroupActionTypes.AddDeviceGroup),
    map((action: actions.AddDeviceGroup) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const param = {
        devices: payload.devices,
        timeZone: payload.timeZone,
        gName: payload.gName,
        otp: '',
        RegionId: payload.companySelectItem
      };
      if (user.isLogin) {
        param.otp = user.otp;
        // payload.account = user.currentUser;
      }
      return this.groupService.AddDeviceGroup(param).pipe(
        map((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeviceGroup };
          if (result.result) {
              return new featureActions.UpdateInfoSuccessAction(result);
          } else {
            const errorResult = result.msg['ExtMsg'] === '0' 
              ? { ...result, errmsg: '0' }
              : result;
            return new featureActions.UpdateInfoFailAction(errorResult);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeviceGroup
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  deleteDeviceGroup$ = createEffect(() => this.actions$.pipe(
    ofType(actions.GroupActionTypes.DeleteDeviceGroup),
    map((action: actions.AddDeviceGroup) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    mergeMap(([payload, user]) => {
      const requestPayload = user.isLogin ? { ...payload, otp: user.otp } : payload;
      return this.groupService.DeleteDeviceGroup(requestPayload).pipe(
        map((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteDeviceGroup };
          if (result.result) {
            return new featureActions.UpdateInfoSuccessAction(result);
          } else {
            return new featureActions.UpdateInfoFailAction(result);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteDeviceGroup
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  readSingleGroup = createEffect(() => this.actions$.pipe(
    ofType(actions.GroupDetailActionTypes.GetGroupDetails),
    map((action: actions.GetGroupDetails) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        gId: payload
      };
      return this.groupService.ReadSingleGroup(params).pipe(
        map((res: any) => {
          if (res.result && res.msg.body.length > 0) {
            return new actions.LoadGroupDetails(res.msg.body[0]);
          } else {
            return new actions.LoadGroupDetails({} as Group);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new actions.LoadGroupDetails({} as Group));
        })
      );
    })
  ));
  updateGroup = createEffect(() => this.actions$.pipe(
    ofType(actions.GroupDetailActionTypes.UpdateGroupDetails),
    map((action: actions.UpdateGroupDetails) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
        const params = {
          gId: payload.Id,
          timeZone: payload.TimeZone,
          desc: payload.Description,
          otp: user.otp
        };
        return this.groupService.UpdateGroup(params).pipe(
          map((res: UpdateInfoModel) => {
            const result = { ...res, type: updateInfoType.EditGroup };
            if (result.result) {
              return new featureActions.UpdateInfoSuccessAction(result);
            } else {
              return new featureActions.UpdateInfoFailAction(result);
            }
          }),
          // TODO: catchError Message調整 --> 已完成
          catchError(error => {
            const res: UpdateInfoModel = {
              result: false,
              errmsg: 'Error',
              type: updateInfoType.EditGroup
            };
            return of(new featureActions.UpdateInfoFailAction(res));
          })
        );
      }
    )
  ));
}
